module.exports = __webpack_public_path__ + "img/passionebeauty-logo.7387d014.png";